import { formatDate } from "@/features/FormCard/utils";
import { useQueryCache } from "@/hooks/useQueyCache";
import { Card, CardBody, CardHeader } from "@heroui/card";
import { Divider } from "@heroui/divider";
import { Input } from "@heroui/input";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

type TInfoCardProps = {
  id: number;
  table_name: string;
  client: string;
  strategy_id_control: Control<any>;
};

interface ItemData {
  id: number;
  created_at: string;
  updated_at: string;
  [key: string]: any;
}

export function TechnicalInfoCardStatic({
  id,
  table_name,
  client,
}: TInfoCardProps) {
  const { t } = useTranslation();
  const data = useQueryCache<ItemData>([client, table_name, "get", "item", id]);

  return (
    <div className="grid place-items-center bg-gray-50 h-full max-w-card w-full">
      <div className="flex justify-center w-full">
        <Card className="p-4 bg-white w-full">
          <CardHeader className="text-sm">
            {t("technical_info.title", {
              defaultValue: "Technical information",
            })}
          </CardHeader>
          <Divider />
          <CardBody>
            <div className="grid grid-cols-2 lg:flex lg:flex-row py-2 gap-3">
              <Input
                radius="full"
                variant="underlined"
                labelPlacement="outside"
                size="sm"
                type="text"
                label={t("technical_info.id", { defaultValue: "ID" })}
                value={id.toString()}
              />
              <Input
                radius="full"
                variant="underlined"
                labelPlacement="outside"
                size="sm"
                type="text"
                label={t("technical_info.created_at", {
                  defaultValue: "Created at",
                })}
                value={formatDate(data?.created_at || "")}
              />
              <Input
                radius="full"
                variant="underlined"
                labelPlacement="outside"
                size="sm"
                type="text"
                label={t("technical_info.updated_at", {
                  defaultValue: "Updated at",
                })}
                value={formatDate(data?.updated_at || "")}
              />
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
